import React, { FC } from 'react';
import { useNavigate } from 'react-router-dom';

import { MatchDayResultScoreCard, useFetchMatchDayResultScoreCard } from '../../../api/hooks/use-fetch-match-day-results-with-scorecard';
import { Button, FlexRowSpaceEvenly } from '../../common-styles/common-styles';
import { Match, Player, PlayerResult } from '../../../../database.schema';
import { useFetchPlayers } from '../../../api/hooks/use-fetch-players';
import * as CSS from '../../match-entry/match-entry-styles';
import { isLoggedIn } from '../../../app/authentication/auth';

type EditResultsCardProps = {
  selectedTournamentIndex: number;
  dayIndex: number;
};
export const EditResults: FC<EditResultsCardProps> = ({ dayIndex, selectedTournamentIndex }): JSX.Element => {
  const navigate = useNavigate();
  const { isLoading, error, data } = useFetchMatchDayResultScoreCard(selectedTournamentIndex, dayIndex);
  const { course, results, format, startingHole } = data as MatchDayResultScoreCard;
  const recordedMatches = { format: format as 'Pairs' | 'Singles', courseId: course.id, matches: results, startingHole };
  const { data: playerList } = useFetchPlayers();
  const players = playerList as Array<Player>;

  if (isLoading) {
    return <div>...loading</div>;
  }

  if (error) {
    return <div>error...</div>;
  }

  return (
    <div>
      <h2>Apply Scores</h2>
      <h3>Course: {course.name}</h3>
      {recordedMatches.matches.map((match: Match, index: number) => (
        <CSS.MatchWrapper key={`stored-match-${index}`} data-testid="match-wrapper">
          {`Match ${index + 1}`}
          <FlexRowSpaceEvenly>
            <CSS.CreatedMatch data-testid={`team1-match-${index}`} bgColour="red">
              <div>
                {match.team1.players.map((player: PlayerResult) => (
                  <div key={`team1-player-${player.playerId}`}>{players.find((player1: Player) => player1.id === player.playerId)?.nickName}</div>
                ))}
              </div>
            </CSS.CreatedMatch>
            v
            <CSS.CreatedMatch data-testid={`team2-match-${index}`} bgColour="blue">
              <div>
                {match.team2.players.map((player: PlayerResult) => (
                  <div key={`team2-player-${player.playerId}`}>{players.find((player1: Player) => player1.id === player.playerId)?.nickName}</div>
                ))}
              </div>
            </CSS.CreatedMatch>
          </FlexRowSpaceEvenly>
          <Button
            data-testid={`update-scores-${index}`}
            onClick={() => {
              navigate(`/scorecard/${selectedTournamentIndex}/${dayIndex}/${index}`);
            }}
          >
            {match.team1.players[0].round.courseHandicap === -1 ? 'Add scores' : 'Edit scores'}
          </Button>
        </CSS.MatchWrapper>
      ))}
      {isLoggedIn() && (
        <Button
          data-testid="quick-results-button"
          onClick={() => {
            navigate(`/quick-results/${selectedTournamentIndex}/${dayIndex}`);
          }}
        >
          Add quick result
        </Button>
      )}
    </div>
  );
};
